import React from 'react';
import StepCodeTag from './shared/StepCodeTag';

const ModernPageWrapper = ({ children, title, subtitle, stepCode, narrow = false, alignLeft = false, wide = false, compactPadding = false }) => {
  return (
    <div
      className="flex-1 bg-gray-50 min-h-screen modern-page-wrapper w-full max-w-full min-w-0 box-border"
      style={{
        padding: compactPadding
          ? '16px 16px'
          : 'clamp(16px, 2vw, 32px) clamp(16px, 2.5vw, 32px)',
      }}
    >
      {/* Page Header */}
      {title && (
        <div
          className={`page-header w-full self-stretch text-left ${
            compactPadding ? 'mb-4' : 'mb-6 lg:mb-8'
          }`}
        >
          <div className="flex items-center justify-start gap-3 flex-wrap w-full">
            {stepCode && <StepCodeTag code={stepCode} size="md" />}
            <h1 className="text-2xl sm:text-3xl font-bold text-gray-900 mb-0 break-words text-left">
              {title}
            </h1>
          </div>
          {subtitle && (
            <p className="text-base sm:text-lg text-gray-600 break-words text-left">
              {subtitle}
            </p>
          )}
        </div>
      )}

      {/* Page Content */}
      <div
        className={
          `bg-white rounded-lg shadow-sm border border-gray-200 min-w-0 ` +
          (narrow
            ? `${wide ? 'w-full p-4 sm:p-5' : 'max-w-2xl p-6 sm:p-8'} ${alignLeft ? '' : 'mx-auto'}`
            : 'p-4 sm:p-6')
        }
      >
        {children}
      </div>
    </div>
  );
};

export default ModernPageWrapper; 